/**
 * Collection Page Ajax Logic
 */

class CollectionPage {
  constructor() {
    const sectionEl = document.querySelector('.collection-page[data-section-id]');
    if (!sectionEl) return;

    this.sectionId = sectionEl.dataset.sectionId;
    this.container = document.getElementById('ProductGridContainer');
    this.filtersForm = document.getElementById('CollectionFiltersForm');
    this.sortSelect = document.getElementById('SortBy');
    this.loadMoreBtn = document.getElementById('AjaxLoadMore');
    this.loadLessBtn = document.getElementById('AjaxLoadLess');
    this.mobileTrigger = document.getElementById('MobileFilterTrigger');
    this.sidebar = document.getElementById('CollectionSidebar');
    this.sidebarClose = document.getElementById('SidebarClose');
    this.overlay = document.getElementById('SidebarOverlay');
    
    this.init();
  }

  init() {
    if (this.filtersForm) {
      this.filtersForm.addEventListener('change', this.handleFilterChange.bind(this));
    }

    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', (e) => {
        const sortInput = this.filtersForm.querySelector('input[name="sort_by"]');
        if (sortInput) sortInput.value = e.target.value;
        this.handleFilterChange();
      });
    }

    if (this.loadMoreBtn) {
      this.loadMoreBtn.addEventListener('click', this.handleLoadMore.bind(this));
    }

    if (this.loadLessBtn) {
      this.loadLessBtn.addEventListener('click', this.handleLoadLess.bind(this));
    }

    // View toggles
    document.querySelectorAll('.view-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const cols = btn.dataset.cols;
        const grid = document.getElementById('product-grid');
        if (grid) {
          grid.className = `product-grid cols-${cols}`;
          document.querySelectorAll('.view-btn').forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
        }
      });
    });

    // Mobile Sidebar
    if (this.mobileTrigger) {
      this.mobileTrigger.addEventListener('click', () => this.toggleSidebar(true));
    }
    if (this.sidebarClose) {
      this.sidebarClose.addEventListener('click', () => this.toggleSidebar(false));
    }
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.toggleSidebar(false));
    }

    // Handle price range inputs with debounce
    let priceDebounce;
    document.querySelectorAll('.price-range input').forEach(input => {
      input.addEventListener('input', () => {
        clearTimeout(priceDebounce);
        priceDebounce = setTimeout(() => this.handleFilterChange(), 1000);
      });
    });

    // Intercept pagination clicks
    document.addEventListener('click', (e) => {
      const link = e.target.closest('.pagination-item');
      if (link && link.tagName === 'A') {
        e.preventDefault();
        this.fetchCollectionContent(link.href);
      }
    });
  }

  toggleSidebar(active) {
    if (active) {
      this.sidebar.classList.add('active');
      this.overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    } else {
      this.sidebar.classList.remove('active');
      this.overlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  handleFilterChange() {
    const formData = new FormData(this.filtersForm);
    const searchParams = new URLSearchParams(formData).toString();
    const url = `${window.location.pathname}?${searchParams}`;
    
    this.fetchCollectionContent(url);
  }

  async fetchCollectionContent(url) {
    const grid = document.getElementById('product-grid');
    if (grid) grid.classList.add('loading');

    try {
      const separator = url.includes('?') ? '&' : '?';
      const response = await fetch(`${url}${separator}section_id=${this.sectionId}`);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      
      const newContent = html.getElementById('ProductGridContainer');
      const newSidebar = html.getElementById('CollectionSidebar');
      const newCount = html.querySelector('.product-count');
      
      if (newContent) this.container.innerHTML = newContent.innerHTML;
      if (newSidebar) this.sidebar.innerHTML = newSidebar.innerHTML;
      
      // Update counts
      const counts = document.querySelectorAll('.product-count, .mobile-product-count');
      if (newCount) {
        counts.forEach(c => c.innerHTML = newCount.innerHTML);
      }

      // Re-init events for new content
      this.reinitEvents();

      // Update URL
      window.history.pushState({ path: url }, '', url);
      
    } catch (error) {
      console.error('Error fetching collection:', error);
    } finally {
      if (grid) grid.classList.remove('loading');
    }
  }

  reinitEvents() {
    // Refresh references
    this.filtersForm = document.getElementById('CollectionFiltersForm');
    this.loadMoreBtn = document.getElementById('AjaxLoadMore');
    this.loadLessBtn = document.getElementById('AjaxLoadLess');
    this.sidebarClose = document.getElementById('SidebarClose');
    
    // Re-bind listeners
    if (this.filtersForm) {
      this.filtersForm.addEventListener('change', this.handleFilterChange.bind(this));
    }
    if (this.loadMoreBtn) {
      this.loadMoreBtn.addEventListener('click', this.handleLoadMore.bind(this));
    }
    if (this.loadLessBtn) {
      this.loadLessBtn.addEventListener('click', this.handleLoadLess.bind(this));
    }
    if (this.sidebarClose) {
      this.sidebarClose.addEventListener('click', () => this.toggleSidebar(false));
    }
  }

  async handleLoadMore() {
    if (!this.loadMoreBtn) return;
    
    const nextUrl = this.loadMoreBtn.dataset.nextUrl;
    if (!nextUrl) return;

    this.loadMoreBtn.innerText = 'LOADING...';
    this.loadMoreBtn.disabled = true;

    try {
      const separator = nextUrl.includes('?') ? '&' : '?';
      const response = await fetch(`${nextUrl}${separator}section_id=${this.sectionId}`);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      
      const newGridItems = html.querySelectorAll('#product-grid > *');
      const newLoadMore = html.getElementById('AjaxLoadMore');
      const currentGrid = document.getElementById('product-grid');
      
      newGridItems.forEach(item => currentGrid.appendChild(item));
      
      if (newLoadMore && newLoadMore.dataset.nextUrl) {
        this.loadMoreBtn.dataset.nextUrl = newLoadMore.dataset.nextUrl;
        this.loadMoreBtn.innerText = 'LOAD MORE PRODUCTS';
        this.loadMoreBtn.disabled = false;
        this.loadMoreBtn.style.display = 'block';
        if (this.loadLessBtn) this.loadLessBtn.style.display = 'none';
      } else {
        this.loadMoreBtn.style.display = 'none';
        if (this.loadLessBtn) this.loadLessBtn.style.display = 'block';
      }

    } catch (error) {
      console.error('Error loading more:', error);
      this.loadMoreBtn.innerText = 'LOAD MORE PRODUCTS';
      this.loadMoreBtn.disabled = false;
    }
  }

  handleLoadLess() {
    // Reset to first page by re-fetching current URL without pagination params
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete('page');
    this.fetchCollectionContent(currentUrl.toString());
    
    // Scroll back to top of products smoothly
    const grid = document.getElementById('product-grid');
    if (grid) {
      grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.collectionPage = new CollectionPage();
});
